import React, { ReactNode } from "react";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlineFileText,
} from "react-icons/ai";
import { FiSettings, FiMap, FiDatabase, FiFileText } from "react-icons/fi";
import { MdAdminPanelSettings, MdOutlineCampaign } from "react-icons/md";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { RiPagesLine } from "react-icons/ri";
import { RoutePermittedRole } from "../shared/constants/AppConst";

export interface RouterConfigData {
  id: string;
  title: string;
  messageId: string;
  icon?: string | ReactNode;
  type: "item" | "group" | "collapse" | "divider";
  children?: RouterConfigData[];
  permittedRole?: RoutePermittedRole;
  color?: string;
  url?: string;
  exact?: boolean;
  count?: number;
}

const routesConfig: RouterConfigData[] = [
  {
    id: "app",
    title: "Application",
    messageId: "sidebar.application",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        messageId: "sidebar.dashboard",
        type: "item",
        icon: <AiOutlineDashboard />,
        url: "/dashboard",
      },
      {
        id: "roleMapping",
        title: "Role Mapping",
        messageId: "sidebar.roleMapping",
        type: "item",
        icon: <MdAdminPanelSettings />,
        url: "/roleMapping",
      },
      {
        id: "transactionMaster",
        title: "Manage Transaction",
        messageId: "sidebar.manageTransaction",
        type: "item",
        icon: <AiOutlineUser />,
        url: "/transaction",
      },
      {
        id: "master",
        title: "Master",
        messageId: "sidebar.master",
        type: "collapse",
        icon: <FiSettings />,
        children: [
          {
            id: "banners",
            title: "Manage Banners",
            messageId: "sidebar.master.banners",
            type: "item",
            icon: <MdOutlineCampaign />,
            url: "/master/manageBanner",
          },
          {
            id: "users",
            title: "Manage Users",
            messageId: "sidebar.master.users",
            type: "item",
            icon: <AiOutlineUser />,
            url: "/master/manageUser",
          },
          {
            id: "roles",
            title: "Manage Role",
            messageId: "sidebar.master.roles",
            type: "item",
            icon: <MdOutlineCampaign />,
            url: "/master/manageRole",
          },
        ],
      },
      {
        id: "polygon",
        title: "Master Polygon",
        messageId: "sidebar.master.polygon",
        type: "collapse",
        icon: <FiMap />,
        children: [
          {
            id: "view",
            title: "Add/Edit Polygon",
            messageId: "sidebar.master.viewPolygon",
            type: "item",
            icon: <FiMap />,
            url: "/master/manageViewPolygon",
          },
          {
            id: "see",
            title: "Polygon See",
            messageId: "sidebar.master.seePolygon",
            type: "item",
            icon: <FiMap />,
            url: "/master/manageSeePolygon",
          },
        ],
      },
      {
        id: "planMaster",
        title: "Plan Master",
        messageId: "sidebar.planMaster",
        type: "collapse",
        icon: <FiDatabase />,
        children: [
          {
            id: "plan",
            title: "View Plan",
            messageId: "sidebar.support.ViewPlan",
            type: "item",
            icon: <FiFileText />,
            url: "/planMaster/ViewPlan",
          },
          {
            id: "pageMapping",
            title: "Plan-Page Mapping",
            messageId: "sidebar.support.planPageMapping",
            type: "item",
            icon: <HiOutlineDocumentReport />,
            url: "/planMaster/planPageMapping",
          },
        ],
      },
      {
        id: "syncMaster",
        title: "Sync Master",
        messageId: "sidebar.syncMaster",
        type: "collapse",
        icon: <FiDatabase />,
        children: [
          {
            id: "sync",
            title: "Sync Data",
            messageId: "sidebar.support.SyncData",
            type: "item",
            icon: <FiDatabase />,
            url: "/syncMaster/syncData",
          },
        ],
      },
      {
        id: "cmsMaster",
        title: "Manage Cms Page",
        messageId: "sidebar.cmsMaster",
        type: "item",
        icon: <RiPagesLine />,
        url: "/pages",
      },
      {
        id: "manageLead",
        title: "Manage Lead",
        messageId: "sidebar.leadMaster",
        type: "collapse",
        icon: <AiOutlineFileText />,
        children: [
          {
            id: "leadMaster",
            title: "Manage Lead",
            messageId: "sidebar.reatilLead",
            type: "item",
            icon: <AiOutlineFileText />,
            url: "/leadManage",
          },
          {
            id: "contactMaster",
            title: "Manage Contact Us",
            messageId: "sidebar.contactMaster",
            type: "item",
            icon: <AiOutlineUser />,
            url: "/contactUs",
          },


          // {
          //   id: "appellateMaster",
          //   title: "Appellate Message",
          //   messageId: "sidebar.appellateMaster",
          //   type: "item",
          //   icon: <FiFileText />,
          //   url: "/appellateMessage",
          // },
          // {
          //   id: "nodelMaster",
          //   title: "Nodel Message",
          //   messageId: "sidebar.nodelMaster",
          //   type: "item",
          //   icon: <FiFileText />,
          //   url: "/nodelMessage",
          // },
        ],
      },
      {
        id: "manageCCLead",
        title: "Manage CC Lead Page",
        messageId: "sidebar.customerCare",
        type: "collapse",
        icon: <AiOutlineFileText />,
        children: [
          {
            id: "customerCare",
            title: "Manage CC Lead Page",
            messageId: "sidebar.ccLeadView",
            type: "item",
            icon: <RiPagesLine />,
            url: "/customerCare/list",
          },
          {
            id: "CustomerPageCreate",
            title: "Add CC Lead",
            messageId: "sidebar.ccLeadCreate",
            type: "item",
            icon: <RiPagesLine />,
            url: "/customerCare/CustomerPageCreate",
          },
        ],
      }
    ],
  },
];

export default routesConfig;
